const keyCodes = {
  DOWN: 40,
  BACKSPACE: 8,
};

export {
  // eslint-disable-next-line import/prefer-default-export
  keyCodes,
};
